export enum GameType {
    X01games,
    Bermuda,
    MickeyMouse,
    TrainingGame131,
    TrainingGame20ies
}